/**
 * LTI Enroll Exam
 * LTI Enroll Exam for Students
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Document from './Document';

/**
 * The EvauInscriptionStatus model module.
 * @module model/EvauInscriptionStatus
 * @version 2.0.0
 */
class EvauInscriptionStatus {
    /**
     * Constructs a new <code>EvauInscriptionStatus</code>.
     * @alias module:model/EvauInscriptionStatus
     */
    constructor() { 
        
        EvauInscriptionStatus.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EvauInscriptionStatus</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EvauInscriptionStatus} obj Optional instance to populate.
     * @return {module:model/EvauInscriptionStatus} The populated <code>EvauInscriptionStatus</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EvauInscriptionStatus();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('student_id')) {
                obj['student_id'] = ApiClient.convertToType(data['student_id'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = ApiClient.convertToType(data['documents'], [Document]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
EvauInscriptionStatus.prototype['id'] = undefined;

/**
 * @member {Number} student_id
 */
EvauInscriptionStatus.prototype['student_id'] = undefined;

/**
 * @member {String} status
 */
EvauInscriptionStatus.prototype['status'] = undefined;

/**
 * @member {Array.<module:model/Document>} documents
 */
EvauInscriptionStatus.prototype['documents'] = undefined;






export default EvauInscriptionStatus;

